import React, { useEffect } from 'react'
import styled from 'styled-components'

import { LoaderCheck } from '@src/components/Check/LoaderCheck'
import {
  MainRouteName,
  RoutingParams,
  useAccountRouter,
} from '@src/hooks/useAccountRouter'

const SuccessText = styled.p`
  margin: 0;
  text-align: center;
  font-size: 18px;
`

export const SuccessScreen = ({
  successText,
  returnToRoute,
}: {
  successText: string
  returnToRoute: RoutingParams<MainRouteName> | null
}): JSX.Element => {
  const { setRoute } = useAccountRouter()

  useEffect(() => {
    const timeout = returnToRoute
      ? window.setTimeout(() => {
          setRoute({
            mainRouteName: returnToRoute.mainRouteName,
            childRouteName: returnToRoute.childRouteName,
            pageDataId: returnToRoute.pageDataId,
          })
        }, 2000)
      : undefined

    return () => {
      if (timeout) {
        clearTimeout(timeout)
      }
    }
  }, [returnToRoute, setRoute])

  return (
    <>
      <LoaderCheck />
      <SuccessText>{successText}</SuccessText>
    </>
  )
}
